import axios from 'axios';
import qs from 'qs';
import { BASEURL } from '../../config';
import CookieLib from '../helpers/cookieLib';
import history from './history';

const getHasRole = () => {
  const path = history.location.pathname;
  if (path.includes('myvendor') || path.includes('myinvoice')) {
    return 'N';
  }
  return CookieLib.getCookieByKey('has_role') === 'true' ? 'Y' : 'N';
};

const createOptions = (
  url,
  apiMethod,
  query,
  isFormData,
  hasRole,
  isBlobRes,
  isFormEncodeInPut,
) => {
  const options = {
    method: apiMethod.toUpperCase(),
    url: BASEURL + url, // Api URL
    headers: {
      Accept: 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json',
      'happay-cid': CookieLib.getCookieByKey('cid'),
      'happay-token': CookieLib.getCookieByKey('token'),
      'HAPPAY-HASROLE': hasRole || getHasRole(),
      'HAPPAY-ORIGIN': 'CHARGECARD',
      'x-csrftoken': Math.random(),
    },
  };

  switch (apiMethod.toLowerCase()) {
    case 'get': {
      options.params = query;
      if (isBlobRes) {
        options.responseType = 'blob';
      }
      break;
    }
    case 'post': {
      if (isFormData) {
        options.headers['Content-Type'] = 'multipart/form-data';
        options.data = query;
      } else {
        options.data = qs.stringify(query);
        options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      }
      break;
    }
    case 'put': {
      if (isFormEncodeInPut) {
        options.data = qs.stringify(query);
        options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      } else {
        options.data = query;
      }
      break;
    }
    case 'delete': {
      options.data = query;
      break;
    }
    default:
      options.data = query;
  }

  return options;
};

export const callApi = (
  url,
  apiMethod,
  query,
  isFormData = false,
  hasRole,
  isBlobRes = false,
  isFormEncodeInPut = false,
) =>
  new Promise((resolve, reject) => {
    const options = createOptions(
      url,
      apiMethod,
      query,
      isFormData,
      hasRole,
      isBlobRes,
      isFormEncodeInPut,
    );
    axios(options)
      .then(response => {
        resolve(handleSuccess(response));
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          if (
            history &&
            history.location &&
            history.location.pathname !== '/logout'
          ) {
            history.push('/logout', {
              apiCall: false,
              message: 'Your session has expired. ',
            });
          } else {
            handleLogout();
          }
        } else {
          reject(
            handleError(
              error.response || {
                status: 0,
                statusText: error.stack,
                data: { res_str: error.message },
              },
            ),
          );
        }
      });
  });
const handleSuccess = response => {
  const { data, headers } = response;
  if (data && headers && headers['happay-cid'] && headers['happay-token']) {
    // data.headers = headers;
    CookieLib.setCookieByKey('cid', headers['happay-cid']);
    CookieLib.setCookieByKey('token', headers['happay-token']);
  }
  return data;
};
const handleError = error => {
  const { status, statusText, data } = error;
  const errRes = {
    status,
    statusText,
    logout: false,
    data,
  };

  return errRes; // message; // I like to get my error message back
};

export const handleLogout = () => {
  CookieLib.clearAllCookies();
  window.location.href = '/login';
};

export const isProdURL = () => {
  const prdURLs = [
    'https://chargecard-api.happay.com/',
    'https://api-v2.happay.in/',
  ];
  return prdURLs.includes(BASEURL);
};

export const getWithoutBaseURL = URL =>
  new Promise((resolve, reject) => {
    axios
      .get(URL)
      .then(response => {
        resolve(handleSuccess(response));
      })
      .catch(error => {
        reject(error);
      });
  });
